"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function jsonrpcFromDefs(definitions, jsonrpc = {}) {
    Object.keys(definitions)
        .filter((key) => { var _a; return Object.keys(((_a = definitions[key]) === null || _a === void 0 ? void 0 : _a.rpc) || {}).length !== 0; })
        .forEach((section) => {
        jsonrpc[section] = {};
        Object.entries(definitions[section].rpc).forEach(([method, def]) => {
            const isSubscription = !!def.pubsub;
            jsonrpc[section][method] = {
                ...def,
                isSubscription,
                jsonrpc: `${section}_${method}`,
                method,
                section
            };
        });
    });
    return jsonrpc;
}
exports.default = jsonrpcFromDefs;
